import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { IApiError } from "../../../../@types/ApiError";
import {
  ErrorItem,
  ErrorsContainer,
  ErrorsList,
  ErrorsTitle,
} from "./WorkflowPublishErrors.styles";

type WorkflowPublishErrorsProps = {
  errors: IApiError[];
  title?: string;
};

/**
 * EN-5191: the translation key for each known publish-validation error code, used only when
 * the backend does not provide a human-readable `message`. Codes, not copy — the code is the
 * contract with the API and must not be translated.
 */
const PUBLISH_ERROR_CODES = [
  "WorkflowRuleTypeNotAvailableForWards",
  "WorkflowMeasurementTypeNotAvailableForWards",
  "WorkflowSurveyNotAvailableForWards",
  "WorkflowArticleNotAvailableForWards",
  "WorkflowInactivityTimezoneMissing",
  "WorkflowDateEventHospitalTimezoneMissing",
  "WorkflowDateEventTargetDatePassed",
];

function getErrorText(error: IApiError, t: TFunction): string {
  if (error.message) {
    return error.message;
  }

  return PUBLISH_ERROR_CODES.includes(error.code)
    ? t(`workflows_publishErrors_codes_${error.code}`)
    : error.code;
}

export function WorkflowPublishErrors({
  errors,
  title,
}: WorkflowPublishErrorsProps) {
  const { t } = useTranslation();

  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <ErrorsContainer>
      <ErrorsTitle>{title ?? t("workflows_publishErrors_title")}</ErrorsTitle>
      <ErrorsList>
        {errors.map((error, index) => (
          <ErrorItem key={`${error.code}-${index}`}>
            {getErrorText(error, t)}
          </ErrorItem>
        ))}
      </ErrorsList>
    </ErrorsContainer>
  );
}

export default WorkflowPublishErrors;
